module.exports = __webpack_public_path__ + "media/images/save_alt-24px-b2b3eb888aa8b8528e48fce73bab23ad.svg";